import { render, staticRenderFns } from "./ruleList.vue?vue&type=template&id=fe6c69b0&scoped=true"
import script from "./ruleList.vue?vue&type=script&lang=js"
export * from "./ruleList.vue?vue&type=script&lang=js"
import style0 from "./ruleList.vue?vue&type=style&index=0&id=fe6c69b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6c69b0",
  null
  
)

export default component.exports